// Framework and third-party non-UI
import React, { useContext } from 'react';

// Redux, contexts, and local helpers/utils/modules
import { DataGridProps } from './types';
import { DataGridContext } from './DataGrid';

// Component specific modules (Component-styled, etc.)
import { StyledDataGridRow } from './DataGrid-styled';

// App components

// Third-party components (buttons, icons, etc.)

const DataGridRow: React.FC<DataGridProps> = ({ children, ...props }) => {
  const dataGridContext = useContext(DataGridContext);
  return (
    <StyledDataGridRow {...dataGridContext} {...props}>
      {children}
    </StyledDataGridRow>
  );
};

export default DataGridRow;
